<template>
  <ModalBaseNew
    :title="'Historie operací kalkulace'"
    :is-visible="props.isVisible"
    :save-allowed="false"
    modal-width="modal-xl"
    close-button-text="Zavřít"
    @update:is-visible="emit('update:isVisible', $event)"
  >
    <div class="table-responsive">
      <table class="table table-hover table-sm">
        <thead class="table-light">
          <tr>
            <th scope="col">Datum a čas</th>
            <th scope="col">Uživatel</th>
            <th scope="col">Akce</th>
            <th scope="col">Popis</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="4" class="text-center py-4">
              <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
              Načítám historii...
            </td>
          </tr>
          <tr v-else-if="logs.length === 0">
            <td colspan="4" class="text-center py-4 text-muted">
              Žádné záznamy v historii nebyly nalezeny.
            </td>
          </tr>
          <tr v-for="log in logs" :key="log.id">
            <td class="text-nowrap">{{ log.created_at }}</td>
            <td class="text-nowrap">{{ log.full_name || 'Systém' }}</td>
            <td class="text-nowrap">
              <span class="badge bg-secondary-subtle text-dark">
                {{ translateAction(log.action) }}
              </span>
            </td>
            <td><small>{{ log.description }}</small></td>
          </tr>
        </tbody>
      </table>
    </div>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="close">Zavřít</button>
    </template>
  </ModalBaseNew>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import ModalBaseNew from '@/components/base/ModalBaseNew.vue';
import myApi from '@/api/api';

const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false
  },
  calculationId: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:isVisible']);

const logs = ref([]);
const loading = ref(false);

const actionTranslations = {
  'create_calculation': 'Vytvoření kalkulace',
  'edit_calculation': 'Úprava kalkulace',
  'delete_calculation': 'Smazání kalkulace',
  'copy_calculation': 'Kopie kalkulace',
  'restore_calculation': 'Obnovení kalkulace',
  'create_version': 'Vytvoření verze',
  'edit_version': 'Úprava verze',
  'delete_version': 'Smazání verze',
  'create_order': 'Vytvoření objednávky',
  'edit_order': 'Úprava objednávky',
  'delete_order': 'Smazání objednávky',
  'confirm_order': 'Potvrzení objednávky',
  'unconfirm_order': 'Zrušení potvrzení objednávky',
  'create_proforma_invoice': 'Vytvoření zálohové faktury',
  'edit_proforma_invoice': 'Úprava zálohové faktury',
  'delete_proforma_invoice': 'Smazání zálohové faktury',
  'create_final_invoice': 'Vytvoření konečné faktury',
  'edit_final_invoice': 'Úprava konečné faktury',
  'delete_final_invoice': 'Smazání konečné faktury'
};

const translateAction = (action) => {
  return actionTranslations[action] || action;
};

const fetchLogs = async () => {
  if (!props.calculationId) return;

  loading.value = true;
  try {
    logs.value = await myApi.getCalculationHistoryLog(props.calculationId);
  } catch (error) {
    console.error("Chyba při načítání logů:", error);
  } finally {
    loading.value = false;
  }
};

const close = () => {
  emit('update:isVisible', false);
  logs.value = [];
};

watch(() => props.isVisible, (newVal) => {
  if (newVal) {
    fetchLogs();
  }
});
</script>

<style scoped>
.table-responsive {
  max-height: 60vh;
  overflow-y: auto;
}

.badge {
  font-weight: 500;
  font-size: 0.85rem;
}
</style>